import React, { useMemo, type ReactNode } from 'react';

import { ButtonItem } from '@atlaskit/menu';
import { MenuList, MenuListItem } from '@atlaskit/navigation-system';
import { ModalEntryPointPressableTrigger } from '@atlassian/jira-modal-entry-point-pressable-trigger/src/ModalEntryPointPressableTrigger.tsx';
import type { Product } from '@atlassian/edition-awareness';

import { standardToPremiumModalEntryPoint } from './entrypoint.tsx';

export type StandardToPremiumModalEntrypointTriggerProps = {
	children: ReactNode;
	cloudId: string;
	product: Product;
	onClick?: () => void;
};

export const StandardToPremiumModalEntrypointTrigger = ({
	children,
	cloudId,
	product,
	onClick,
}: StandardToPremiumModalEntrypointTriggerProps) => {
	const entryPointProps = useMemo(
		() => ({
			cloudId,
			product,
		}),
		[cloudId, product],
	);

	return (
		<ModalEntryPointPressableTrigger
			entryPoint={standardToPremiumModalEntryPoint}
			entryPointProps={entryPointProps}
			interactionName="standard-to-premium-modal"
			useInternalModal
			modalProps={{
				width: 'x-large',
				shouldCloseOnOverlayClick: true,
				shouldCloseOnEscapePress: true,
			}}
		>
			{({ ref }) => (
				<MenuList>
					<MenuListItem>
						<ButtonItem onClick={onClick} ref={ref}>
							{children}
						</ButtonItem>
					</MenuListItem>
				</MenuList>
			)}
		</ModalEntryPointPressableTrigger>
	);
};
